// Global variable
var variantIdInv = ''
window.__acPdpSizeMemory = window.__acPdpSizeMemory || { value: '' }

function isSizeOptionName(name) {
  return (name || '').toLowerCase().indexOf('size') > -1
}

function getAcPdpSizeMemory() {
  const mem = window.__acPdpSizeMemory
  if (mem && mem.value) return mem.value
  if (window.__acLastSelectedSize && window.__acLastSelectedSize.selectedValue) {
    return window.__acLastSelectedSize.selectedValue
  }
  return ''
}

function setAcPdpSizeMemory(value) {
  if (!value) {
    window.__acPdpSizeMemory.value = ''
    if (window.__acLastSelectedSize) window.__acLastSelectedSize.selectedValue = ''
    return
  }
  window.__acPdpSizeMemory.value = value
  if (window.__acLastSelectedSize) window.__acLastSelectedSize.selectedValue = value
}

window.setAcPdpSizeMemory = setAcPdpSizeMemory
window.getAcPdpSizeMemory = getAcPdpSizeMemory

function normalizeSizeKey(value) {
  return (value || '').trim().toLowerCase()
}

function findSizeVariantButtonIn(root) {
  const scope = root || document
  const buttons = scope.querySelectorAll('variant-button[data-option-name]')
  for (const btn of buttons) {
    if (isSizeOptionName(btn.getAttribute('data-option-name'))) return btn
  }
  return null
}

function findSizeRadioInput(sizeField, sizeValue) {
  if (!sizeField || !sizeValue) return null
  const key = normalizeSizeKey(sizeValue)
  let targetInput = null
  sizeField.querySelectorAll('input[type="radio"]').forEach((input) => {
    if (normalizeSizeKey(input.value) === key) targetInput = input
  })
  return targetInput
}

function findSizePickerFieldIn(root) {
  const scope = root || document
  const picker = scope.querySelector ? scope.querySelector('variant-picker') : null
  const searchRoot = picker || scope
  if (!searchRoot.querySelectorAll) return null
  for (const field of searchRoot.querySelectorAll('[data-picker-field]')) {
    if (isSizeOptionName(field.getAttribute('data-option-name'))) return field
  }
  return null
}

function getVariantOptionValues(variant) {
  if (!variant) return []
  if (Array.isArray(variant.options) && variant.options.length) {
    return variant.options
  }
  const values = []
  if (variant.option1 != null && variant.option1 !== '') values.push(variant.option1)
  if (variant.option2 != null && variant.option2 !== '') values.push(variant.option2)
  if (variant.option3 != null && variant.option3 !== '') values.push(variant.option3)
  return values
}

function applyPickerFieldValue(field, value) {
  if (!field || value == null || value === '') return false

  if (field.dataset.pickerField === 'radio') {
    const targetInput = findSizeRadioInput(field, value)
    if (!targetInput || isSizeRadioDisabled(targetInput)) return false
    if (targetInput.checked && field.getAttribute('data-selected-value') === targetInput.value) {
      return false
    }
    targetInput.checked = true
    field.setAttribute('data-selected-value', targetInput.value)
    const label = field.querySelector('.option-label--selected')
    if (label) label.textContent = targetInput.value
    return true
  }

  if (field.dataset.pickerField === 'select') {
    const select = field.querySelector('select')
    if (!select || select.value === value) return false
    select.value = value
    field.setAttribute('data-selected-value', value)
    const label = field.querySelector('.option-label--selected')
    if (label) label.textContent = value
    return true
  }

  return false
}

function applyAcPdpVariantSelection(variant) {
  const main = document.querySelector('.m-main-product')
  if (!main || !variant) return false

  const picker = main.querySelector('variant-picker')
  if (!picker) return false

  const optionValues = getVariantOptionValues(variant)
  if (!optionValues.length) return false

  const fields = Array.from(picker.querySelectorAll('[data-picker-field]'))
  let applied = false

  fields.forEach((field, index) => {
    if (applyPickerFieldValue(field, optionValues[index])) applied = true
  })

  if (!applied) return false

  const sizeField = findSizePickerFieldIn(main)
  if (sizeField) {
    const sizeIndex = fields.indexOf(sizeField)
    const sizeValue = sizeIndex >= 0 ? optionValues[sizeIndex] : ''
    if (sizeValue) setAcPdpSizeMemory(sizeValue)
  }

  window.__acPdpSuppressStickySelectChange = true
  try {
    picker.dispatchEvent(
      new CustomEvent('triggerOnVariantChange', {
        bubbles: true,
        cancelable: true,
      })
    )
  } finally {
    window.__acPdpSuppressStickySelectChange = false
  }

  return true
}

window.getVariantOptionValues = getVariantOptionValues
window.applyAcPdpVariantSelection = applyAcPdpVariantSelection

function isSizeRadioDisabled(input) {
  if (!input || input.disabled) return true
  const node = input.closest('.m-product-option--node')
  if (!node) return false
  // Sold-out sizes stay faded + crossed but remain selectable, so the shopper can
  // land on the out-of-stock variant and the back-in-stock (xflow) Notify Me can show.
  // Only truly impossible combinations (__unavailable) or explicit disables are blocked.
  return (
    node.classList.contains('m-product-option--node__unavailable') ||
    node.classList.contains('disabled') ||
    node.getAttribute('aria-disabled') === 'true'
  )
}

function applyAcPdpSizeRadioSelection(sizeField, targetInput, options) {
  options = options || {}
  if (!sizeField || !targetInput || isSizeRadioDisabled(targetInput)) return false

  targetInput.checked = true
  sizeField.setAttribute('data-selected-value', targetInput.value)
  const label = sizeField.querySelector('.option-label--selected')
  if (label) label.textContent = targetInput.value
  if (options.updateMemory !== false) setAcPdpSizeMemory(targetInput.value)
  targetInput.dispatchEvent(new Event('change', { bubbles: true }))
  return true
}

window.applyAcPdpSizeRadioSelection = applyAcPdpSizeRadioSelection
window.findMainProductSizeVariantButton = function () {
  const main = document.querySelector('.m-main-product')
  return main ? findSizeVariantButtonIn(main) : null
}

if (!customElements.get('variant-picker')) {
  class t extends HTMLElement {
    constructor() {
      super(),
        (this.selectors = {
          container: '[data-variant-picker]',
          productInfo: '.m-product-info--wrapper',
          error: '.m-product-form-message',
          variantIdInput: '[name="id"]',
          pickerFields: ['[data-picker-field]'],
          optionNodes: ['.m-product-option--node'],
          productSku: '[data-variant-sku]',
          productAvailability: '[data-availability]',
          shareUrlInput: '[data-share-url]',
          stockCountdown: '.prod__stock-countdown',
          productWrapper: '.m-main-product--wrapper',
        }),
        (this.container = this.closest(this.selectors.container)),
        (this.productWrapper = this.closest(this.selectors.productWrapper)),
        (this.productInfo = this.closest(this.selectors.productInfo)),
        (this.domNodes = queryDomNodes(this.selectors, this.productInfo))
    }
    updateLowStockMessage(variant) {
      const wrapper = this.section?.querySelector('[data-low-stock]') || document.querySelector('[data-low-stock]')
      if (!wrapper) return

      const qtyNode = wrapper.querySelector('[data-low-stock-qty]') || wrapper.querySelector('.selected-value-color')
      const sizeRequired = wrapper.getAttribute('data-size-required') === 'true'

      // If no variant is selected (e.g. size not selected), we must not show inventory.
      if (!variant) {
        if (qtyNode) qtyNode.textContent = ''
        wrapper.classList.add('hidden')
        // Keep the "lowval" red styling class untouched; just hide.
        return
      }

      const qty = Number(variant.inventory_quantity ?? 0)
      const isLow = qty > 0 && qty <= 5

      // Even when sizeRequired is false (single default variant), only show when low.
      if (qtyNode) qtyNode.textContent = String(qty)
      wrapper.classList.toggle('hidden', !isLow || (sizeRequired && !variant))
    }
    connectedCallback() {
      this.setupData()
      // this.addEventListener('click',function(){
      // })
      setTimeout(
        function () {
          const checkedInput = this.querySelector('input:checked')
          if (checkedInput) {
            let selectedSize = {
              optionName: 'Size',
              selectedValue: checkedInput.value,
            }
          }
        }.bind(this),
        300
      )
      // Listen for the custom event
      this.addEventListener('triggerOnVariantChange', (e) => {
        this.onVariantChange()
      })

      //     document.addEventListener('ProductVariantDataUpdated', function(){
      //     this.getVariantData(); // Re-fetch variant data
      //       console.log("Refectch data");
      //        this.onVariantChange();
      //     // Any additional update logic needed
      // }.bind(this));
    }
    async setupData() {
      let t = (window._themeProducts || {})[this.container.dataset.productId]
      ;(this.productId = this.container.dataset.productId),
        (this.sectionId = this.container.dataset.section),
        (this.productUrl = this.container.dataset.productUrl),
        (this.productHandle = this.container.dataset.productHandle),
        (this.section = this.container.closest(`[data-section-id="${this.sectionId}"]`)),
        (this.variantData = this.getVariantData()),
        (this.productData = Object.assign(await this.getProductJson(), t)),
        (this.showFeaturedMedia = 'true' === this.dataset.showFeaturedMedia),
        (this.enableVariantGroupImages = 'true' === this.container.dataset.enableVariantGroupImages),
        this.enableVariantGroupImages && (this.variantGroupImages = this.getVariantGroupImageData())
      // Check if any picker field has no checked radio (e.g. size not pre-selected)
      let hasUncheckedPicker = Array.from(this.querySelectorAll('[data-picker-field="radio"]')).some(
        field => !field.querySelector('input:checked')
      )
      if (hasUncheckedPicker && this.restorePersistedSizeOption()) {
        hasUncheckedPicker = Array.from(this.querySelectorAll('[data-picker-field="radio"]')).some(
          field => !field.querySelector('input:checked')
        )
      }
      if (hasUncheckedPicker) {
        this.sizeNotSelected = true
        this.currentVariant = null
        this.productData.current_variant_id = null
        this.productData.initialVariant = null
        this.updateLowStockMessage(null)
        this.updateButton(true, 'SELECT SIZE', false)
        this.getMediaGallery()
        this.initOptionSwatches()
        this.addEventListener('change', this.onVariantChange)
        return
      }
      this.getSelectedOptions()
      this.getSelectedVariant()
      if (!this.currentVariant) {
        const e = this.productInfo.querySelector(this.selectors.variantIdInput).value
        this.currentVariant = this.productData.variants.find((t) => t.id === Number(e))
      }
      if (this.currentVariant) {
        this.sizeNotSelected = false
        this.persistSelectedSizeFromOptions()
      }
      ;(this.productData.current_variant_id = this.currentVariant && this.currentVariant.id),
        (this.productData.initialVariant = this.currentVariant),
        this.currentVariant &&
          (this.getDataImageVariant(this.currentVariant.id),
          this.hideSoldOutAndUnavailableOptions(),
          this.updateButton(!this.currentVariant.available, '', !1),
          this.updateVariantInput()),
        this.updateLowStockMessage(this.currentVariant),
        this.getMediaGallery(),
        document.addEventListener('matchMobile', () => {
          this.getMediaGallery()
        }),
        document.addEventListener('unmatchMobile', () => {
          this.getMediaGallery()
        }),
        this.initOptionSwatches(),
        this.addEventListener('change', this.onVariantChange)
    }
    getMediaGallery() {
      ;(this.mediaGallery = this.section.querySelectorAll('media-gallery')),
        (this.check = setInterval(() => {
          this.mediaGallery &&
            this.mediaGallery.forEach((t) => {
              'none' !== window.getComputedStyle(t).display &&
                t.mediaMode &&
                (clearInterval(this.check),
                (this.layout = t.layout),
                (this.media = t),
                'slider' === t.mediaMode
                  ? ((this.slides = t.slider.slides), t.navSlider && (this.slidesNav = t.navSlider.slides))
                  : (this.mediaItems = t.querySelectorAll('.m-product-media--item')),
                (!this.showFeaturedMedia || (this.enableVariantGroupImages && this.variantGroupImages.enable)) &&
                  this.updateMedia())
            })
        }, 100))
    }
    onVariantChange() {
      this.getSelectedOptions(),
        this.getSelectedVariant(),
        this.updateButton(!0, '', !1),
        this.updatePickupAvailability(),
        this.removeErrorMessage(),
        this.currentVariant
          ? ((this.sizeNotSelected = false),
            this.persistSelectedSizeFromOptions(),
            this.getDataImageVariant(this.currentVariant.id),
            this.updateMedia(),
            this.updateBrowserHistory(),
            this.updateVariantInput(),
            this.updateProductMeta(),
            this.updatePrice(),
            this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut),
            this.hideSoldOutAndUnavailableOptions(),
            this.updateLowStockMessage(this.currentVariant))
          : (this.options && this.options.some(function(o) { return o === null || o === undefined })
              ? (this.updateButton(true, 'SELECT SIZE', true), this.updateLowStockMessage(null))
              : (this.updateButton(!0, '', !0), this.setUnavailable())),
        window.MinimogEvents.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this)
      // Update the global variantIdInv with the current variant ID
      variantIdInv = this.currentVariant ? this.currentVariant.id : ''
      //this.updateInventoryDisplay(this.currentVariant);
      if (jdgm.customizeBadges) {
        setTimeout(function () {
          jdgm.customizeBadges()
        }, 20)
      }
    }
    updateInventoryDisplay(variant) {
      const inventoryDisplay = document.querySelector('.selected-value-color')
      const inventorymain = document.querySelector('.inventoryWrapper-main')
      console.log('Size Inentory:', variant.inventory_quantity)

      if (inventoryDisplay) {
        if (variant && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          inventoryDisplay.textContent = variant.inventory_quantity

          inventorymain.classList.remove('hidden')
        } else {
          inventoryDisplay.textContent = '0' // Default value when no stock
          inventorymain.classList.add('hidden')
        }
      }
    }
    getDataImageVariant(t) {
      this.variantGroupImages &&
        this.variantGroupImages.enable &&
        (this.currentVariantMedia = this.variantGroupImages.mapping.find((e) => Number(e.id) === t).media)
    }
    getProductJson() {
      return JSON.parse(this.productWrapper.querySelector("#productData[type='application/json']").textContent)
      // return fetch(this.productUrl + ".js").then((t => {
      //     if (t.ok) return t.json();
      //     return JSON.parse(this.productWrapper.querySelector("#productData[type='application/json']").textContent)
      // })).catch((t => {}))
    }
    getSelectedVariant() {
      console.log('(this.productData, this.options)', this.productData, this.options)
      // If any option is not selected (null), no variant can be determined
      if (this.options.some(o => o === null || o === undefined)) {
        this.currentVariant = null
        return
      }
      let t = getVariantFromOptionArray(this.productData, this.options),
        e = [...this.options]
      t ||
        (e.pop(),
        (t = getVariantFromOptionArray(this.productData, e)),
        t || (e.pop(), (t = getVariantFromOptionArray(this.productData, e))),
        (this.options = [...t.options]),
        this.updateSelectedOptions()),
        (this.currentVariant = t)
    }
    findSizePickerField() {
      for (const field of this.querySelectorAll('[data-picker-field]')) {
        if (isSizeOptionName(field.getAttribute('data-option-name'))) return field
      }
      return null
    }
    restorePersistedSizeOption() {
      const persisted = getAcPdpSizeMemory()
      if (!persisted) return false
      const sizeField = this.findSizePickerField()
      if (!sizeField) return false
      const targetInput = findSizeRadioInput(sizeField, persisted)
      if (!targetInput) {
        setAcPdpSizeMemory('')
        return false
      }
      if (!applyAcPdpSizeRadioSelection(sizeField, targetInput)) {
        setAcPdpSizeMemory('')
        return false
      }
      return true
    }
    persistSelectedSizeFromOptions() {
      const sizeField = this.findSizePickerField()
      if (!sizeField || !this.options) return
      const fields = Array.from(this.querySelectorAll('[data-picker-field]'))
      const pos = fields.indexOf(sizeField)
      if (pos < 0) return
      const sizeValue = this.options[pos]
      if (sizeValue) setAcPdpSizeMemory(sizeValue)
    }
    getSelectedOptions() {
      const t = Array.from(this.querySelectorAll('[data-picker-field]'))
      this.options = t.map((t) => {
        if ('radio' === t.dataset.pickerField) {
          const checked = Array.from(t.querySelectorAll('input')).find((t) => t.checked)
          return checked ? checked.value : null
        }
        return t.querySelector('select').value
      })
    }
    updateSelectedOptions() {
      this.domNodes.pickerFields.forEach((t, e) => {
        if (t.dataset.selectedValue !== this.options[e]) {
          const a = t.querySelector(`input[value="${this.options[e].replace(/["\\]/g, '\\$&')}"]`)
          a && ((a.checked = !0), t.updateSelectedValue())
        }
      })
    }
    updateMedia() {
      if (!this.currentVariant) return
      let t = [],
        e = [],
        a = 0,
        i = 0,
        s = 0,
        r = 0
      if (this.variantGroupImages && this.variantGroupImages.enable)
        if ('slider' === this.media.mediaMode && this.slides)
          this.slides.forEach((e) => {
            const s = e.querySelector('[data-media-id]').dataset.mediaId
            this.currentVariantMedia && this.currentVariantMedia.length > 0
              ? (this.currentVariantMedia.includes(s) &&
                  ((e.dataset.swiperSlideIndex = a++),
                  (e.dataset.index = i++),
                  '0' === e.dataset.swiperSlideIndex && e.classList.add('swiper-slide-active'),
                  t.push(e)),
                e.classList.contains('media-type-image') ||
                  ((e.dataset.swiperSlideIndex = a++), (e.dataset.index = i++), t.push(e)))
              : ((e.dataset.swiperSlideIndex = a++), (e.dataset.index = i++), t.push(e))
          }),
            this.media.slider.removeAllSlides(),
            this.media.slider.appendSlide(t),
            'layout-7' == this.layout ? this.media.slider.slideToLoop(1) : this.media.slider.slideToLoop(0),
            this.media.handleSlideChange(),
            this.slidesNav &&
              this.slidesNav.forEach((t) => {
                const a = t.querySelector('[data-media-id]').dataset.mediaId
                this.currentVariantMedia && this.currentVariantMedia.length > 0
                  ? (this.currentVariantMedia.includes(a) &&
                      ((t.dataset.swiperSlideIndex = s++),
                      (t.dataset.index = r++),
                      '0' === t.dataset.swiperSlideIndex && t.classList.add('swiper-slide-thumb-active'),
                      e.push(t)),
                    t.classList.contains('media-type-image') ||
                      ((t.dataset.swiperSlideIndex = s++), (t.dataset.index = r++), e.push(t)))
                  : ((t.dataset.swiperSlideIndex = s++),
                    (t.dataset.index = r++),
                    t.classList.remove('swiper-slide-thumb-active'),
                    '0' === t.dataset.swiperSlideIndex && t.classList.add('swiper-slide-thumb-active'),
                    e.push(t))
              }),
            this.media.navSlider && this.media.navSlider.removeAllSlides(),
            this.media.navSlider && this.media.navSlider.appendSlide(e),
            this.media.navSlider && this.media.navSlider.slideToLoop(0),
            this.media && this.media.removeAttribute('data-media-loading'),
            this.media && (this.media.firstElementChild.style.opacity = 1)
        else {
          let e = 0
          const a = this.media.querySelector('.m-product-media--list')
          this.mediaItems &&
            this.mediaItems.forEach((i) => {
              const s = i.querySelector('[data-media-id]').dataset.mediaId
              this.currentVariantMedia && this.currentVariantMedia.length > 0
                ? (this.currentVariantMedia.includes(s) && ((i.dataset.index = e++), t.push(i)),
                  i.classList.contains('media-type-image') || ((i.dataset.index = e++), t.push(i)))
                : ((i.dataset.index = e++), t.push(i)),
                (a.innerHTML = ''),
                t.forEach((t) => {
                  if ('layout-2' == this.layout) {
                    t.classList.remove('m-col-span-2')
                    0 == t.dataset.index % 3 && t.classList.add('m-col-span-2')
                  }
                  a.append(t)
                })
            }),
            this.media && this.media.removeAttribute('data-media-loading'),
            this.media && (this.media.firstElementChild.style.opacity = 1)
        }
      else {
        parseInt(this.media && this.media.dataset.mediaSize) > 0 && this.media.setActiveMedia(this.currentVariant)
      }
      const n = []
      t.length > 0 &&
        t.forEach((t, e) => {
          if ('image' === t.dataset.mediaType) {
            const e = t.querySelector('.m-product-media').dataset
            n.push({
              src: e.mediaSrc,
              width: parseInt(e.mediaWidth),
              height: parseInt(e.mediaHeight),
              alt: e.mediaAlt,
              id: t.dataset.index,
            })
          } else
            n.push({
              html: `<div class="pswp__${t.dataset.mediaType}">${t.innerHTML}</div>`,
              type: t.dataset.mediaType,
              id: t.dataset.index,
            })
        }),
        this.media && this.media.lightbox && this.media.lightbox.destroy(),
        this.media && this.media.handlePhotoswipe(n),
        this.media && this.media.initPhotoswipe()
    }
    updateBrowserHistory() {
      this.currentVariant &&
        'false' !== this.dataset.updateUrl &&
        window.history.replaceState({}, '', `${this.productUrl}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
      if (!this.currentVariant) return
      const nextVariantId = String(this.currentVariant.id)
      document
        .querySelectorAll(
          `#product-form-${this.sectionId}, #sticky-atc-form-${this.sectionId}, #product-form-installment`
        )
        .forEach((t) => {
          const e = t.querySelector(this.selectors.variantIdInput)
          if (!e) return
          const changed = e.value !== nextVariantId
          e.value = nextVariantId
          if (changed && !window.__acPdpSuppressStickySelectChange) {
            e.dispatchEvent(
              new Event('change', {
                bubbles: !0,
              })
            )
          }
        })
    }
    updatePickupAvailability() {
      const t = this.section.querySelector('pickup-availability')
      t &&
        (this.currentVariant && this.currentVariant.available
          ? t.fetchAvailability(this.currentVariant.id)
          : (t.removeAttribute('available'), (t.innerHTML = '')))
    }
    removeErrorMessage() {
      const t = this.closest('section')
      if (!t) return
      const e = t.querySelector('product-form')
      e && e.handleErrorMessage()
    }
    updatePrice() {
      const t = 'm-price--on-sale',
        e = 'm-price--sold-out',
        a = this.productInfo.querySelector('.main-product__block-price')
      if (!a) return
      const i = window.MinimogSettings.money_format,
        {
          priceWrapper: s,
          salePrice: r,
          unitPrice: n,
          compareAtPrice: d,
          saleBadge: o,
          saleAmount: l,
          unitPriceWrapper: c,
        } = queryDomNodes(
          {
            priceWrapper: '.m-price',
            salePrice: '.m-price-item--sale',
            compareAtPrice: ['.m-price-item--regular'],
            unitPrice: '.m-price__unit',
            unitPriceWrapper: '.m-price__unit-wrapper',
            saleBadge: '.m-price__badge-sale',
            saleAmount: '[data-saved-price]',
          },
          a
        ),
        { compare_at_price: u, price: h, unit_price_measurement: p } = this.currentVariant,
        m = s.dataset.saleBadgeType,
        v = u && u > h,
        g = !this.currentVariant.available
      if (
        (v ? s.classList.add(t) : s.classList.remove(t),
        g ? s.classList.add(e) : s.classList.remove(e),
        s && s.classList.remove('visibility-hidden'),
        r && (r.innerHTML = formatMoney(h, i)),
        d.length && u > h
          ? d.forEach((t) => (t.innerHTML = formatMoney(u, i)))
          : d.forEach((t) => (t.innerHTML = formatMoney(h, i))),
        o && u > h && 'text' !== m)
      ) {
        let t
        if ('fixed_amount' === m) t = formatMoney(u - h, i)
        else {
          const e = (100 * (u - h)) / u
          t = Math.round(e) + '%'
        }
        l.textContent = t
      }
      if (p && n) {
        c.classList.remove('m:hidden')
        const t = `<span>${formatMoney(this.currentVariant.unit_price, i)}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`
        n.innerHTML = t
      } else c.classList.add('m:hidden')
    }
    _getBaseUnit = () =>
      1 === this.currentVariant.unit_price_measurement.reference_value
        ? this.currentVariant.unit_price_measurement.reference_unit
        : this.currentVariant.unit_price_measurement.reference_value +
          this.currentVariant.unit_price_measurement.reference_unit
    updateButton(t = !0, e, a = !0) {
      const i = document.querySelectorAll(`.product-form-${this.sectionId}`)
      i &&
        i.forEach((a) => {
          const i = a.querySelector('[name="add"]'),
            s = a.querySelector('.m-product-dynamic-checkout'),
            r = a.querySelector('[name="add"] > .m-add-to-cart--text')
          i &&
            (t
              ? (i.setAttribute('disabled', 'disabled'),
                i.classList.add('disabled'),
                s && s.classList.add('disabled'),
                e && (r.textContent = e))
              : (i.removeAttribute('disabled'),
                i.classList.remove('disabled'),
                s && s.classList.remove('disabled'),
                (r.textContent = window.MinimogStrings.addToCart)))
        })
    }
    updateProductMeta() {
      const { available: t, sku: e } = this.currentVariant,
        { inStock: a, outOfStock: i } = window.MinimogStrings,
        s = this.section.querySelector(this.selectors.productAvailability),
        r = this.section.querySelector(this.selectors.productSku)
      if ((r && (r.textContent = e || 'N/A'), s)) {
        const e = t ? 'remove' : 'add'
        ;(s.textContent = t ? a : i), s.classList[e]('m-product-availability--outofstock')
      }
    }
    setUnavailable() {
      const t = document.getElementById(`product-form-${this.sectionId}`),
        e = t.querySelector('[name="add"]'),
        a = t.querySelector('[name="add"] > span.m-add-to-cart--text'),
        i = this.section.querySelector('.m-price')
      e && ((a.textContent = window.MinimogStrings.unavailable), i && i.classList.add('visibility-hidden'))
    }
    hideSoldOutAndUnavailableOptions = () => {
      const t = 'm-product-option--node__soldout',
        e = 'm-product-option--node__unavailable',
        a = this.currentVariant,
        { optionNodes: i } = this.domNodes,
        {
          productData: s,
          productData: {
            variants: r,
            options: { length: n },
          },
        } = this
      i.forEach((i) => {
        const { optionPosition: d, value: o } = i.dataset,
          l = Number(d),
          c = 'OPTION' === i.tagName
        let u = []
        if (l === n) {
          const t = Array.from(a.options)
          ;(t[n - 1] = o), u.push(getVariantFromOptionArray(s, t))
        } else u = r.filter((t) => t.options[l - 1] === o && t.options[l - 2] === a['option' + (l - 1)])
        if (((u = u.filter(Boolean)), u.length)) {
          i.classList.remove(e), c && i.removeAttribute('disabled')
          const a = u.every((t) => !1 === t.available) ? 'add' : 'remove'
          i.classList[a](t)
        } else i.classList.add(e), c && i.setAttribute('disabled', 'true')
      })
    }
    getVariantData() {
      return (
        (this.variantData =
          this.variantData ||
          JSON.parse(this.container.querySelector('#productVariants[type="application/json"]').textContent)),
        this.variantData
      )
    }
    getVariantGroupImageData() {
      return (
        (this.variantGroupImages =
          this.variantGroupImages ||
          JSON.parse(this.container.querySelector('#variantGroup[type="application/json"]').textContent)),
        this.variantGroupImages
      )
    }
    initOptionSwatches() {
      const { _colorSwatches: t = [], _imageSwatches: e = [] } = window.MinimogSettings
      this.domNodes.optionNodes &&
        this.domNodes.optionNodes.forEach((a) => {
          const { optionType: i, optionPosition: s, value: r } = a.dataset,
            n = r.toLowerCase(),
            d = this.variantData.find((t) => t[`option${s}`] === r),
            o = d && d.featured_image && d.featured_image.src ? getSizedImageUrl(d.featured_image.src, '100x') : null,
            l = e.find((t) => t.key === n) ? e.find((t) => t.key === n).value : '',
            c = t.find((t) => t.key === n) ? t.find((t) => t.key === n).value : ''
          switch (((o || l) && a.querySelector('label') && a.querySelector('label').classList.add('has-bg-img'), i)) {
            case 'default':
              ;(a.querySelector('label').style.backgroundImage = `url(${l || o || ''})`),
                a.querySelector('label').classList.remove('option-loading')
              break
            case 'image':
              ;(a.querySelector('label').style.backgroundImage = `url(${o || l || ''})`),
                a.querySelector('label').classList.remove('option-loading')
              break
            case 'color':
              ;(a.querySelector('label').style.backgroundColor = c || n),
                l && (a.querySelector('label').style.backgroundImage = `url(${l})`),
                a.querySelector('label').classList.remove('option-loading')
          }
        })
    }
  }
  customElements.define('variant-picker', t)
}
if (!customElements.get('variant-button')) {
  class t extends HTMLElement {
    constructor() {
      super()
      this.selectedSpan = this.querySelector('.option-label--selected')
      this.container = this.closest('[data-variant-picker]')
      this.addEventListener('change', this.updateSelectedValue)
      if (isSizeOptionName(this.getAttribute('data-option-name'))) {
        this.addEventListener('click', this.handleSizeOptionClick)
      }
    }

    handleSizeOptionClick(event) {
      const node = event.target.closest('.m-product-option--node')
      if (!node || !this.contains(node)) return
      const input = node.querySelector('input[type="radio"]')
      if (!input || input.disabled) return
      requestAnimationFrame(() => {
        if (input.checked) this.updateSelectedValue()
      })
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.container.querySelector('#productVariants[type="application/json"]').textContent)
      return this.variantData
    }

    updateInventoryDisplay(variant) {
      const inventoryDisplay = document.querySelector('.selected-value-color')
      if (inventoryDisplay) {
        const inventoryQuantity = variant ? variant.inventory_quantity : 0
        inventoryDisplay.textContent = inventoryQuantity > 0 ? inventoryQuantity : '0'
      }
    }

    updateSelectedValue() {
      const checked = Array.from(this.querySelectorAll('input')).find((input) => input.checked)
      if (!checked) return
      this.value = checked.value
      this.setAttribute('data-selected-value', this.value)
      if (this.selectedSpan) this.selectedSpan.textContent = this.value
      if (isSizeOptionName(this.getAttribute('data-option-name'))) {
        setAcPdpSizeMemory(this.value)
      }
      const selectedVariantData = this.getVariantData()
      // this.updateInventoryDisplay(selectedVariantData);

      let event = new CustomEvent('triggerOnVariantChange', {
        bubbles: true,
        cancelable: true,
      })
      this.dispatchEvent(event)
    }

    connectedCallback() {
      if (jdgm.customizeBadges) {
        jdgm.customizeBadges()
      }
    }
  }
  if ((customElements.define('variant-button', t), !customElements.get('variant-select'))) {
    class e extends t {
      constructor() {
        super()
      }
      updateSelectedValue() {
        ;(this.value = this.querySelector('select').value),
          this.setAttribute('data-selected-value', this.value),
          this.selectedSpan && (this.selectedSpan.textContent = this.value)
      }
    }
    customElements.define('variant-select', e)
  }
  if (!customElements.get('variant-image')) {
    class e extends t {
      constructor() {
        super()
      }
    }
    customElements.define('variant-image', e)
  }
  if (!customElements.get('variant-color')) {
    class e extends t {
      constructor() {
        super()
      }
    }
    customElements.define('variant-color', e)
  }
}
